import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { adminApi } from './adminApi';
import { DataTable, EmptyState, PageHeader, SearchInput } from './kit';
import Pagination from './Pagination';
import { PlateTag, useSlashToSearch } from './ui';

const integer = new Intl.NumberFormat('pt-BR');
const PLATE = /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/;
const cleanPlate = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

const COLUMNS = [
  { key: 'plate', label: 'Placa', width: '140px', render: (v) => <PlateTag value={v.plate} /> },
  { key: 'model', label: 'Veículo', render: (v) => [v.brand, v.model].filter(Boolean).join(' ') || '—' },
  { key: 'owner', label: 'Dono', render: (v) => (v.owner ? v.owner.name : '—') },
];

// Manutencoes: veiculos das garagens (sem precisar da placa); a placa digitada vai direto ao historico.
export default function MaintenancesPage() {
  const history = useHistory();
  useSlashToSearch('ax-plate-search');
  const [plate, setPlate] = useState('');
  const [page, setPage] = useState(1);
  const [state, setState] = useState({ status: 'loading', results: [], total: 0, pages: 1, error: null });

  useEffect(() => {
    let active = true;
    setState((previous) => ({ ...previous, status: 'loading', error: null }));
    adminApi.listVehicles({ page, pageSize: 10 })
      .then((data) => { if (active) setState({ status: 'done', results: data.results || [], total: data.total || 0, pages: data.pages || 1, error: null }); })
      .catch(() => { if (active) setState((previous) => ({ ...previous, status: 'error', error: 'Não foi possível carregar os veículos.' })); });
    return () => { active = false; };
  }, [page]);

  const typed = cleanPlate(plate);
  const openPlate = (value) => history.push(`/admin/maintenances/${cleanPlate(value)}`);
  const count = state.results.length;

  return (
    <div className='ax-page'>
      <PageHeader title='Manutenções' meta={state.total ? `${integer.format(state.total)} veículos nas garagens` : null} />

      <form className='ax-toolbar' onSubmit={(e) => { e.preventDefault(); if (PLATE.test(typed)) openPlate(typed); }}>
        <SearchInput id='ax-plate-search' value={plate} onChange={(value) => setPlate(value.toUpperCase())} placeholder='Placa do veículo (ex.: ABC1D23)' />
        <button type='submit' className='ax-btn ax-btn-primary' disabled={!PLATE.test(typed)}>Ver histórico</button>
      </form>

      {state.error && <p className='ax-alert' role='alert'>{state.error}</p>}

      <DataTable
        columns={COLUMNS}
        rows={state.results}
        rowKey={(v) => v.id}
        onRowClick={(v) => openPlate(v.plate)}
        loading={state.status === 'loading'}
        empty={state.status === 'done' ? <EmptyState title='Nenhum veículo nas garagens' text='Digite a placa acima para ver o histórico de qualquer veículo.' /> : null}
      />

      {state.total > 0 && (
        <div className='ax-footer'>
          <span className='ax-muted'>{integer.format((page - 1) * 10 + 1)}–{integer.format((page - 1) * 10 + count)} de {integer.format(state.total)}</span>
          <Pagination page={page} pages={state.pages} onChange={setPage} disabled={state.status === 'loading'} />
        </div>
      )}
    </div>
  );
}
